import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/ktx/transplantation-screening/lab-procedures/otherLabProcedure";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	otherLabProcedure: {
		id: "ktx.otherLabProcedure.title",
		defaultMessage: "Egyéb laborvizsgálat"
	},
	summary: {
		id: "ktx.otherLabProcedure.field.summary",
		defaultMessage:
			"Lelet tartalma (Leiden mutáció, MTHFR, Thrombophylia, Immunszerológia, Komplement, tumormarker, Egyéb)"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["summary"],
		label: messages.summary,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "ktx_otherLabProcedure",
	value: {
		schemaId: "otherLabProcedure",
		title: messages.otherLabProcedure,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
